<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>TO JANET AND DAVID AND THEIR CONTEMPORARIES</p>
<p class="ded">WHO MUST CARRY THE TORCH OF LIBERTY ON ITS NEXT LAP</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-friedman-capitalism-0005.vue?6142ce37